import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

// components
import { RightArrow } from "components/common";

const SmallCards = ({ appLinkCount, qnaCount, ...props }) => {
  const navigate = useNavigate();
  const { branchUseYn, seqPartnerBranch } = useSelector(
    (state) => state.partner
  );
  const disabled = branchUseYn === "Y" && seqPartnerBranch === 0;

  const handleClick = (path) => {
    if (disabled) return null;
    return navigate(path);
  };

  return (
    <MainWrapper>
      <CardWrapper onClick={() => handleClick("/all/app-link")}>
        <Text disabled={disabled}>회원 앱 연동</Text>
        <CountWrapper>
          <Text className="count" disabled={disabled}>
            {disabled ? 0 : appLinkCount ? appLinkCount : 0} <span>건</span>
          </Text>
          <RightArrow size="S" />
        </CountWrapper>
      </CardWrapper>

      <CardWrapper onClick={() => handleClick("/all/qna")}>
        <Text disabled={disabled}>문의 사항</Text>
        <CountWrapper>
          <Text className="count" disabled={disabled}>
            {disabled ? 0 : qnaCount ? qnaCount : 0} <span>건</span>
          </Text>
          <RightArrow size="S" />
        </CountWrapper>
      </CardWrapper>
    </MainWrapper>
  );
};

const MainWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  width: 100%;
  div:first-child {
    margin-right: 10px;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 20px 24px;
  border-radius: 12px;
  width: 100%;
  height: 90px;
  background-color: ${(props) => props.theme.colors.cardBackground};
`;

const CountWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
`;

const Text = styled.p`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.2px;
  color: ${(props) =>
    props.disabled ? "#D4D9E3" : props.theme.colors.primaryTextColor};

  &.count {
    font-size: 18px;
    font-feature-settings: "tnum" on, "lnum" on;
    color: ${(props) =>
      props.disabled ? "#D4D9E3" : props.theme.colors.activeTextColor};
    span {
      color: ${(props) =>
        props.disabled ? "#D4D9E3" : props.theme.colors.primaryTextColor};
    }
  }
`;

SmallCards.propTypes = {
  memberCount: PropTypes.number,
  qnaCount: PropTypes.number,
  onMemberCardClick: PropTypes.func,
  onQnaCardClick: PropTypes.func,
};

export default SmallCards;
